function sliderServicesCarousel() {
    document.querySelectorAll('.services_carousel_swiper-js').forEach(function(swiperContainer) {
        new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 24,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
            pagination: {
                el: swiperContainer.closest('.container').querySelector('.services_carousel_pagination-js'),
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1025: {
                    slidesPerView: 3,
                },
            },
        });
    });
}

$(function() {
    sliderServicesCarousel();
});
